export enum Languages {
  En = 'en',
  Cz = 'cz',
}